<h2 mat-dialog-title class="pdf-dialog-title">
  Build Your Report
  <button mat-icon-button class="dialog-close-btn" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="pdf-dialog-content">
  <div class="pdf-dialog-layout">
    <!-- Left panel -->
    <div class="pdf-left-panel">
      <div class="pdf-field-group">
        <label class="pdf-field-label">Report Title</label>
        <mat-form-field appearance="outline" class="pdf-full-width">
          <input matInput [(ngModel)]="title" placeholder="Portfolio Report" />
        </mat-form-field>
      </div>

      <div class="pdf-field-group">
        <label class="pdf-field-label">Subtitle</label>
        <mat-form-field appearance="outline" class="pdf-full-width">
          <input
            matInput
            [(ngModel)]="subtitle"
            placeholder="e.g. Performance Overview: Jan 1, 2020 to Dec 31, 2023"
          />
        </mat-form-field>
      </div>

      <div class="pdf-field-group">
        <label class="pdf-field-label">Theme</label>
        <div class="seg pdf-theme-toggle">
          <button
            type="button"
            [class.active]="theme === 'light'"
            (click)="theme = 'light'"
          >
            Light
          </button>
          <button
            type="button"
            [class.active]="theme === 'dark'"
            (click)="theme = 'dark'"
          >
            Dark
          </button>
        </div>
      </div>

      <div class="pdf-section-header">
        <span class="pdf-section-title">Select Content</span>
        <span class="pdf-section-hint">Select which sections to include:</span>
      </div>

      <div class="pdf-sections-list">
        <div class="pdf-select-all-row">
          <mat-checkbox
            [checked]="allSelected()"
            [indeterminate]="someSelected()"
            (change)="onToggleAll($event.checked)"
            color="primary"
          >
            Select All
          </mat-checkbox>
        </div>
        @for (group of sectionGroups(); track trackByGroup($index, group)) {
          <div>
            <div class="pdf-group-label">{{ group.title }}</div>
            @for (
              section of group.sections;
              track trackBySection($index, section)
            ) {
              <div class="pdf-section-item">
                <mat-checkbox
                  [checked]="section.selected"
                  (change)="onSectionToggle(section, $event.checked)"
                  color="primary"
                >
                  {{ section.label }}
                </mat-checkbox>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Right panel -->
    <div class="pdf-right-panel">
      <div class="pdf-section-header">
        <span class="pdf-section-title">Report Structure</span>
        <span class="pdf-section-hint">Drag sections to reorder:</span>
      </div>

      <div
        cdkDropList
        class="pdf-ordered-list"
        (cdkDropListDropped)="onDrop($event)"
      >
        @for (
          section of orderedSections();
          track trackBySection($index, section)
        ) {
          <div cdkDrag class="pdf-ordered-item">
            <mat-icon class="pdf-drag-handle" cdkDragHandle
              >drag_indicator</mat-icon
            >
            <mat-checkbox
              [checked]="true"
              color="primary"
              (change)="onSectionToggle(section, $event.checked)"
            >
              {{ section.label }}
            </mat-checkbox>
          </div>
        }

        @if (orderedSections().length === 0) {
          <div class="pdf-empty-order">
            No sections selected. Check items on the left to add them.
          </div>
        }
      </div>

      @if (error()) {
        <div class="pdf-error-msg">
          <mat-icon
            class="align-middle"
            style="font-size: 16px; height: 16px; width: 16px"
            >error_outline</mat-icon
          >
          {{ error() }}
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pdf-dialog-actions">
  <button
    mat-stroked-button
    (click)="dialogRef.close()"
    [disabled]="exporting()"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="onExport()"
    [disabled]="!canExport()"
    class="ms-2 has-inline-spinner"
  >
    @if (exporting()) {
      <mat-spinner
        diameter="18"
        class="d-inline-block align-middle me-1"
      ></mat-spinner>
    }
    @if (!exporting()) {
      <mat-icon
        class="align-middle me-1"
        style="font-size: 18px; height: 18px; width: 18px"
        >download</mat-icon
      >
    }
    <span class="align-middle">Export PDF</span>
  </button>
</mat-dialog-actions>
